<div class="item-header">
  <button class="btn btn-light d-sm-none" id="menu-toggle" (click)="toggleSidebar()">
      <span class="menu-icon"></span>
  </button>
  <a (click)="redirectToRouter()" class="nav-link"><i class="back-icon"></i>{{title}}</a>
</div>
